import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function SubscriptionCanceledPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-gray-100 rounded-full p-4">
            <XCircle className="h-16 w-16 text-gray-600" />
          </div>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Checkout Canceled
        </h1>

        <p className="text-gray-600 mb-6">
          You've canceled the checkout process. No charges have been made.
        </p>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-blue-800">
            If you experienced any issues or have questions, please contact our support team.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/plans')}
            className="w-full py-3 px-4 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          >
            View Plans Again
          </button>

          <button
            onClick={() => navigate('/plans')}
            className="w-full py-3 px-4 bg-gray-200 text-gray-700 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
          >
            View Plans & Billing
          </button>
        </div>
      </div>
    </div>
  );
}
